<template>
	<div class="positionLi">
		<div v-if="itemData" class="top" @click="poDetails()">
			<div class="info">
				<div class="left">
					<img v-if="itemData.top==1" src='@/static/pinnedIcon.png' class="icon" />
					<img v-else-if="itemData.is_selected==1" src='@/static/winnowIcon.png' class="icon" />
					<img v-else-if="itemData.type==2" src='@/static/jobIcon.png' class="icon" />
					<div class="title">
						{{itemData.position_name}}
					</div>
				</div>
				<div class="pay" v-if="itemData.type=='2'">{{itemData.salary_part_time_job}}</div>
				<div class="pay" v-else>
					{{`${parseFloat((itemData.salary_min/1000).toFixed(1))}-${parseFloat((itemData.salary_max/1000).toFixed(1))}k`}}
				</div>
			</div>
			<div class="label">
				<div class="li">
					{{itemData.address.split('-')[1]}}
				</div>
				<div v-if="itemData.tag_name_others" class="li">
					{{itemData.tag_name_others.split(',')[0]}}
				</div>
				<div class="li">
					{{itemData.tag_name_qualifications}}
				</div>
			</div>
		</div>
		<div v-if="type==1&&itemData.company" class="bottom" @click="toCompany()">
			<el-image :src="itemData.company.logo||require('@/static/company.png')" fit="cover" class="logo"></el-image>
			<div>
				{{itemData.company.company_name}} {{itemData.company.person_count}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['type','itemData'],
		data() {
			return {

			}
		},
		created() {

		},
		methods: {
			poDetails(){
				this.$router.push({ name: 'positionDe',query: {id:this.itemData.id } });
			},
			toCompany(){
				this.$router.push({ name: 'companyDe',query: {id:this.itemData.company.id} });
			}
		}
	}
</script>

<style lang="scss" scoped>
	.positionLi {
		position: relative;
		z-index: 2;
		background-color: #fff;
		border-radius: 16px;
		width: 392px;
		padding: 18px 23px;
		box-sizing: border-box;
		cursor: pointer;
		.top {
			.info {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 15px;
				
				.left{
					display: flex;
					align-items: center;
					.icon{
						width: 43px;
						height: 20px;
						margin-right: 10px;
					}
				}
				
				.title {
					color: #151515;
					font-size: 18px;
					width: 240px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-weight: bold;
				}

				.pay {
					color: #51A190;
					font-size: 15px;
				}
			}

			.label {
				display: flex;
				align-items: center;

				.li {
					padding: 3px 14px;
					background-color: #F5F5F5;
					border-radius: 2px;
					color: #5E5E5E;
					font-size: 13px;
					display: block;
					margin-right: 8px;
					max-width: 80px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					&:last-child {
						margin-right: 0;
					}
				}
			}
		}

		.bottom {
			color: #151515;
			font-size: 14px;
			display: flex;
			align-items: center;
			margin-top: 35px;

			.logo {
				margin-right: 12px;
				border-radius: 2px;
				width: 24px;
				height: 24px;
			}
		}
	}
</style>